type GenPathSuffixOptions = { experimentName: string; variantName: string; currentUserId: string };

type GenPathSuffix = (data: GenPathSuffixOptions) => string;

const GENERATORS: Readonly<Record<'facebook' | 'whatsapp' | 'copy', GenPathSuffix>> = {
	facebook: ({ experimentName, variantName, currentUserId }: GenPathSuffixOptions) =>
		`/nftexp/${experimentName}/${variantName}/${currentUserId}`,
	copy: ({ experimentName, variantName, currentUserId }: GenPathSuffixOptions) =>
		`/exp/cl_/${experimentName}/${variantName}/${currentUserId}`,
	whatsapp: ({ experimentName, variantName, currentUserId }: GenPathSuffixOptions) =>
		`/exp/wa/${experimentName}/${variantName}/${currentUserId}`,
};

const GENERATORS_V2: Readonly<Record<'facebook' | 'whatsapp' | 'copy' | 'twitter', GenPathSuffix>> = {
	facebook: ({ experimentName, variantName, currentUserId }: GenPathSuffixOptions) =>
		`/exp/v2/fb/${experimentName}/${variantName}/${currentUserId}`,
	copy: ({ experimentName, variantName, currentUserId }: GenPathSuffixOptions) =>
		`/exp/v2/cl_/${experimentName}/${variantName}/${currentUserId}`,
	whatsapp: ({ experimentName, variantName, currentUserId }: GenPathSuffixOptions) =>
		`/exp/v2/wa/${experimentName}/${variantName}/${currentUserId}`,
	twitter: ({ experimentName, variantName, currentUserId }: GenPathSuffixOptions) =>
		`/exp/v2/tw/${experimentName}/${variantName}/${currentUserId}`,
};

export function getPathSuffixGenerator(channel: 'facebook' | 'whatsapp' | 'copy'): GenPathSuffix {
	return GENERATORS[channel];
}

export function getPathSuffixGeneratorV2(channel: 'facebook' | 'whatsapp' | 'copy' | 'twitter'): GenPathSuffix {
	return GENERATORS_V2[channel];
}
